export default __webpack_public_path__ + "static/Quote_Image_Tablet-87df0c4204ef8fd48df32193b6648952.jpg";